import { RECORD_SOURCE } from '@stash/shared-types';
import type { Contact, Meta, StashCard, StashCategory, Stasher, Vendor } from '@stash/shared-types';
import type { StashCardActivity, StashCardNote } from '@stash/shared-types';

const ACKERMAN_CARD_ID = 'demo-ackerman-1';
const ACKERMAN_STASHER_ID = 'stasher-jess';

export const DEMO_CURRENT_USER_ID = 'stasher-russ';
const ME = DEMO_CURRENT_USER_ID;
const META: Meta = {
  createdAt: new Date('2024-01-01'),
  updatedAt: new Date('2024-01-01'),
  appVersion: 'demo',
};

// --- Categories ---

const catRestaurants: StashCategory = { recordID: 'cat-restaurants', name: 'Restaurants', imageUrl: 'https://images.unsplash.com/photo-1592861956120-e524fc739696?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' };
const catHome: StashCategory = { recordID: 'cat-home', name: 'Home Services', imageUrl: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' };
const catHealth: StashCategory = { recordID: 'cat-health', name: 'Health & Wellness', imageUrl: 'https://plus.unsplash.com/premium_photo-1673953509975-576678fa6710?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' };
const catShopping: StashCategory = { recordID: 'cat-shopping', name: 'Shopping', imageUrl: 'https://plus.unsplash.com/premium_photo-1683141052679-942eb9e77760?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' };
const catAuto: StashCategory = { recordID: 'cat-auto', name: 'Auto & Transport', imageUrl: 'https://images.unsplash.com/photo-1493238792000-8113da705763?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' };
const catBeauty: StashCategory = { recordID: 'cat-beauty', name: 'Beauty', imageUrl: 'https://plus.unsplash.com/premium_photo-1661404164814-9d3c137097aa?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' };
const catItalian: StashCategory = { recordID: 'cat-italian', name: 'Italian', parentCategoryID: 'cat-restaurants', imageUrl: 'https://images.unsplash.com/photo-1600891964599-f61ba0e24092?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' };
const catCasual: StashCategory = { recordID: 'cat-casual', name: 'Casual', parentCategoryID: 'cat-restaurants', imageUrl: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' };
const catPlumbing: StashCategory = { recordID: 'cat-plumbing', name: 'Plumbing', parentCategoryID: 'cat-home',  };
const catElectrical: StashCategory = { recordID: 'cat-electrical', name: 'Electrical', parentCategoryID: 'cat-home' };
const catSkincare: StashCategory = { recordID: 'cat-skincare', name: 'Skincare', parentCategoryID: 'cat-health' };
const catFitness: StashCategory = { recordID: 'cat-fitness', name: 'Fitness', parentCategoryID: 'cat-health' };
const catBooks: StashCategory = { recordID: 'cat-books', name: 'Books', parentCategoryID: 'cat-shopping' };
const catMechanic: StashCategory = { recordID: 'cat-mechanic', name: 'Mechanic', parentCategoryID: 'cat-auto' };
const catHair: StashCategory = { recordID: 'cat-hair', name: 'Hair', parentCategoryID: 'cat-beauty' };
const catSecurity: StashCategory = { recordID: 'cat-security', name: 'Security', parentCategoryID: 'cat-home' };

export const DEMO_CATEGORIES: StashCategory[] = [
  catRestaurants, catHome, catHealth, catShopping, catAuto, catBeauty,
  catItalian, catCasual, catPlumbing, catElectrical, catSecurity,
  catSkincare, catFitness, catBooks, catMechanic, catHair,
];

// --- Stashers ---

export const DEMO_STASHERS: Stasher[] = [
  {
    recordID: 'stasher-russ',
    meta: META,
    firstName: 'Russ',
    lastName: 'Z.',
    visibility: 'generalPublic',
    signUpCountry: 'USA',
    homeBases: [],
    vendorPlaylists: [],
    fcmTokens: [],
    userRoles: [],
  },
  {
    recordID: 'stasher-sarah',
    meta: META,
    firstName: 'Sarah',
    lastName: 'M.',
    visibility: 'generalPublic',
    signUpCountry: 'USA',
    homeBases: [],
    vendorPlaylists: [],
    fcmTokens: [],
    userRoles: [],
  },
  {
    recordID: 'stasher-mike',
    meta: META,
    firstName: 'Mike',
    lastName: 'T.',
    visibility: 'generalPublic',
    signUpCountry: 'USA',
    homeBases: [],
    vendorPlaylists: [],
    fcmTokens: [],
    userRoles: [],
  },
  {
    recordID: 'stasher-jess',
    meta: META,
    firstName: 'Jess',
    lastName: 'L.',
    visibility: 'generalPublic',
    signUpCountry: 'USA',
    homeBases: [],
    vendorPlaylists: [],
    fcmTokens: [],
    userRoles: [],
  },
  {
    recordID: 'stasher-david',
    meta: META,
    firstName: 'David',
    lastName: 'K.',
    visibility: 'generalPublic',
    signUpCountry: 'USA',
    homeBases: [],
    vendorPlaylists: [],
    fcmTokens: [],
    userRoles: [],
  },
];

// --- Vendors (Buckhead Atlanta area, ≈ 33.84°N, 84.38°W) ---

const vendorPizza: Vendor = {
  recordID: 'vendor-pizza',
  meta: META,
  companyName: 'Rosetta Stone Pizza',
  companyDescription: 'Authentic Neapolitan pizza in the heart of Buckhead. Wood-fired oven, fresh ingredients imported weekly from Italy.',
  contactName: 'Marco Esposito',
  businessPhone: '(404) 555-0182',
  businessEmail: 'info@rosettastonepizza.com',
  websiteUrl: 'https://www.rosettastonepizza.com',
  additionalContacts: [
    { phone: { number: '(404) 555-0183', label: 'Reservations' } },
  ] as Contact[],
  categories: [catItalian],
  stashCardStasherIds: ['stasher-russ', 'stasher-sarah'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '3050 Peachtree Rd NW', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30305', lat: 33.8421, lng: -84.3801 },
};

const vendorTacos: Vendor = {
  recordID: 'vendor-tacos',
  meta: META,
  companyName: 'Los Tres Compadres',
  companyDescription: 'Family-owned taqueria serving authentic street tacos and hand-pressed tortillas since 1998. Cash only.',
  businessPhone: '(404) 555-0247',
  categories: [catCasual],
  stashCardStasherIds: ['stasher-mike', 'stasher-jess'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '2955 Peachtree Rd NE', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30305', lat: 33.8389, lng: -84.3834 },
};

const vendorPlumb: Vendor = {
  recordID: 'vendor-plumb',
  meta: META,
  companyName: 'Hartley Plumbing',
  companyDescription: 'Licensed master plumber serving the Atlanta metro for 20+ years. Emergency service available 24/7. No job too small.',
  contactName: 'Dale Hartley',
  businessPhone: '(404) 555-0311',
  businessEmail: 'dale@hartleyplumbing.com',
  websiteUrl: 'https://www.hartleyplumbing.com',
  additionalContacts: [
    { phone: { number: '(404) 555-0312', label: 'Emergency' } },
  ] as Contact[],
  categories: [catPlumbing],
  stashCardStasherIds: ['stasher-russ', 'stasher-mike'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '2700 Peachtree Rd NW', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30305', lat: 33.8302, lng: -84.3654 },
};

const vendorSecurity: Vendor = {
  recordID: ACKERMAN_CARD_ID,
  meta: META,
  companyName: 'Ackerman Security',
  companyDescription: '\Family-owned security company specializing in home alarm systems, smart locks, and 24/7 monitoring. Excellent customer service.',
  contactName: 'Jules Ackerman',
  businessPhone: '(404) 555-0999',
  businessEmail: 'jules@ackermansecurity.com',
  websiteUrl: 'https://www.ackermansecurity.com',
  additionalContacts: [] as Contact[],
  categories: [catSecurity],
  stashCardStasherIds: ['stasher-russ', ACKERMAN_STASHER_ID],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '3600 Peachtree Rd NE', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30326', lat: 33.8505, lng: -84.3728 },
};

const vendorGlow: Vendor = {
  recordID: 'vendor-glow',
  meta: META,
  companyName: 'Glow Skin Studio',
  companyDescription: 'Results-driven skincare studio specializing in clinical facials, chemical peels, and advanced LED treatments.',
  contactName: 'Alana Chen',
  businessPhone: '(404) 555-0428',
  businessEmail: 'book@glowskinstudio.com',
  websiteUrl: 'https://www.glowskinstudio.com',
  additionalContacts: [
    { email: { email: 'alana@glowskinstudio.com', label: 'Alana direct' } },
  ] as Contact[],
  categories: [catSkincare],
  stashCardStasherIds: ['stasher-russ', 'stasher-sarah', 'stasher-jess'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '3340 Peachtree Rd NE', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30326', lat: 33.8445, lng: -84.3712 },
};

const vendorBooks: Vendor = {
  recordID: 'vendor-books',
  meta: META,
  companyName: 'Buckhead Books',
  companyDescription: 'Independent bookstore with hand-curated selections, monthly author events, and Saturday storytime for kids.',
  businessPhone: '(404) 555-0519',
  businessEmail: 'hello@buckheadbooks.com',
  websiteUrl: 'https://www.buckheadbooks.com',
  categories: [catBooks],
  stashCardStasherIds: ['stasher-david'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '3060 Peachtree Rd NW', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30305', lat: 33.8367, lng: -84.3891 },
};

const vendorAuto: Vendor = {
  recordID: 'vendor-auto',
  meta: META,
  companyName: 'Precision Auto Care',
  companyDescription: 'ASE-certified mechanics specializing in European and domestic vehicles. Honest written estimates, no upselling.',
  contactName: 'Kevin Park',
  businessPhone: '(404) 555-0634',
  additionalContacts: [
    { phone: { number: '(404) 555-0635', label: 'After hours' } },
  ] as Contact[],
  categories: [catMechanic],
  stashCardStasherIds: ['stasher-russ', 'stasher-mike'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '2200 Peachtree Rd NW', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30309', lat: 33.8199, lng: -84.3943 },
};

const vendorElectric: Vendor = {
  recordID: 'vendor-electric',
  meta: META,
  companyName: "Electric Mike's",
  companyDescription: 'Licensed electrical contractor. Panel upgrades, EV charger installs, whole-home rewires. Pulls permits every time.',
  contactName: 'Mike Tran',
  businessPhone: '(404) 555-0751',
  businessEmail: 'mike@electricmikes.com',
  categories: [catElectrical],
  stashCardStasherIds: ['stasher-russ'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '3500 Peachtree Rd NE', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30326', lat: 33.8488, lng: -84.3776 },
};

const vendorCrossfit: Vendor = {
  recordID: 'vendor-crossfit',
  meta: META,
  companyName: 'CrossFit Buckhead',
  companyDescription: 'Affiliated CrossFit gym offering 5am–7pm classes seven days a week. All fitness levels welcome. Free intro class.',
  businessPhone: '(404) 555-0862',
  businessEmail: 'info@crossfitbuckhead.com',
  websiteUrl: 'https://www.crossfitbuckhead.com',
  additionalContacts: [
    { email: { email: 'coaches@crossfitbuckhead.com', label: 'Coaching staff' } },
  ] as Contact[],
  categories: [catFitness],
  stashCardStasherIds: ['stasher-jess'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '3100 Roswell Rd NW', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30305', lat: 33.8412, lng: -84.3822 },
};

const vendorHair: Vendor = {
  recordID: 'vendor-hair',
  meta: META,
  companyName: 'The Hair Room',
  companyDescription: 'Boutique salon known for precision cuts and lived-in balayage. Walk-ins welcome Tuesday through Thursday.',
  contactName: 'Tomás Reyes',
  businessPhone: '(404) 555-0973',
  websiteUrl: 'https://www.thehairroomatl.com',
  additionalContacts: [
    { phone: { number: '(404) 555-0974', label: 'Bookings' } },
    { email: { email: 'tomas@thehairroomatl.com', label: 'Tomás direct' } },
  ] as Contact[],
  categories: [catHair],
  stashCardStasherIds: ['stasher-russ', 'stasher-sarah'],
  importNotes: '',
  recordSource: RECORD_SOURCE.IOS_APP,
  address: { street: '2870 Peachtree Rd NW', city: 'Atlanta', region: 'GA', countryCode: 'USA', postalCode: '30305', lat: 33.8355, lng: -84.3759 },
};

export const DEMO_VENDORS: Vendor[] = [
  vendorPizza, vendorTacos, vendorPlumb, vendorGlow, vendorBooks,
  vendorAuto, vendorElectric, vendorCrossfit, vendorHair,
];

// -- StashCardActivity & StashCardNote ---


const ackermanActivities: StashCardActivity[] = [
  { id: 'a1', activityType: { call: { phone: '(404) 555-0000' } },
    stashCardId: ACKERMAN_CARD_ID, stasherId: ME,
    title: 'Called Tom', detail: 'Booked Tuesday 9–11. Under-warranty inspection — no charge.',
    createdOn: daysAgo(4) },
  { id: 'a2', activityType: { sms: { phone: '(404) 555-0000' } },
    stashCardId: ACKERMAN_CARD_ID, stasherId: ME,
    title: 'Text from dispatch', detail: 'Confirmed for Tue 9–11. Tom will be your tech.',
    createdOn: daysAgo(5) },
  { id: 'a3', activityType: { website: { urlString: 'https://example.com' } },
    stashCardId: ACKERMAN_CARD_ID, stasherId: ME,
    title: 'Visited website', detail: 'Browsed camera package pricing.',
    createdOn: daysAgo(30) },
  { id: 'a4', activityType: { call: { phone: '(404) 555-0000' } },
    stashCardId: ACKERMAN_CARD_ID, stasherId: ME,
    title: 'After-hours service call', detail: 'Back-door sensor triggered. Tom dispatched a tech within the hour — replaced on site. No charge.',
    createdOn: daysAgo(21) },
];

const ackermanNotes: StashCardNote[] = [
  { recordID: 'n1', stashCardId: ACKERMAN_CARD_ID,
    title: 'Annual inspection complete',
    detail: 'New keypad installed in the kitchen — code reset to 4892. Tom flagged the back-door sensor for replacement next quarter.',
    isPrivate: false, attachments: [],
    createdOn: daysAgo(4) },
  // Featured-quote note — written by the recommender (Selena), pulled to the
  // StashCard page's quote slot.
  { recordID: 'n2', stashCardId: ACKERMAN_CARD_ID,
    title: 'Why we use them',
    detail: "We've had them four years. Tom's personally answered every after-hours call. They sent a tech at 2 AM when our back-door sensor went off.",
    isPrivate: false, attachments: [],
    createdOn: daysAgo(180) },
];

function daysAgo(n: number): Date {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d;
}

// --- StashCards ---

export const DEMO_STASH_CARDS: StashCard[] = [
  {
    recordID: 'card-01',
    stasherId: 'stasher-russ',
    vendor: vendorPizza,
    tags: ['date-night', 'italian'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-01', stashCardId: 'card-01', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'The margherita is incredible. Get the burrata appetizer.',
    }],
    stashCardActivities: [
      { id: 'act-01a', activityType: { call: { phone: '(404) 555-0000' } }, stashCardId: 'card-01', stasherId: 'stasher-russ', title: 'Call', detail: '', createdOn: new Date('2024-03-10') },
      { id: 'act-01b', activityType: { call: { phone: '(404) 555-0000' } }, stashCardId: 'card-01', stasherId: 'stasher-russ', title: 'Call', detail: '', createdOn: new Date('2024-02-20') },
    ],
  },
  {
    recordID: 'card-02',
    stasherId: 'stasher-sarah',
    vendor: vendorPizza,
    tags: ['date-night'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-02', stashCardId: 'card-02', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Great for date night. Bring cash.',
    }],
  },
  {
    recordID: 'card-02b',
    stasherId: 'stasher-mike',
    vendor: vendorTacos,
    tags: ['casual', 'tacos', 'lunch'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-02b', stashCardId: 'card-02b', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-02-10'),
      detail: 'Best street tacos in Buckhead. Get the al pastor.',
    }],
  },
  {
    recordID: 'card-02c',
    stasherId: 'stasher-jess',
    vendor: vendorTacos,
    tags: ['casual', 'cheap-eats'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-02c', stashCardId: 'card-02c', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-03-01'),
      detail: 'Huge portions, great margaritas. Go early on weekends.',
    }],
  },
  {
    recordID: 'card-03',
    stasherId: 'stasher-mike',
    vendor: vendorPlumb,
    tags: ['reliable', 'emergency'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-03', stashCardId: 'card-03', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Called at 11pm, showed up in 30 min. Fair price.',
    }],
    stashCardActivities: [
      { id: 'act-03a', activityType: { sms: { phone: '(404) 555-0000' } }, stashCardId: 'card-03', stasherId: 'stasher-mike', title: 'SMS', detail: '', createdOn: new Date('2024-03-05') },
      { id: 'act-03b', activityType: { call: { phone: '(404) 555-0000' } }, stashCardId: 'card-03', stasherId: 'stasher-mike', title: 'Call', detail: '', createdOn: new Date('2024-02-15') },
    ],
  },
  {
    recordID: 'card-04',
    stasherId: 'stasher-russ',
    vendor: vendorPlumb,
    tags: ['reliable'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-04', stashCardId: 'card-04', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Super reliable. Saved me during a burst pipe.',
    }],
  },
  {
    recordID: 'card-05',
    stasherId: 'stasher-jess',
    vendor: vendorGlow,
    tags: ['facial', 'skincare'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-05', stashCardId: 'card-05', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: "Best facial I've ever had. Book with Alana.",
    }],
  },
  {
    recordID: 'card-06',
    stasherId: 'stasher-sarah',
    vendor: vendorGlow,
    tags: ['skincare'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-06', stashCardId: 'card-06', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Ask for the oxygen facial. Worth every penny.',
    }],
  },
  {
    recordID: 'card-07',
    stasherId: 'stasher-russ',
    vendor: vendorGlow,
    tags: ['gift-card'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-07', stashCardId: 'card-07', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Great for a gift card.',
    }],
  },
  {
    recordID: 'card-08',
    stasherId: 'stasher-david',
    vendor: vendorBooks,
    tags: ['indie', 'family-friendly'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-08', stashCardId: 'card-08', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Amazing indie bookstore. Story time on Saturdays.',
    }],
  },
  {
    recordID: 'card-09',
    stasherId: 'stasher-russ',
    vendor: vendorAuto,
    tags: ['mechanic', 'honest'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-09', stashCardId: 'card-09', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Honest mechanic. Talked me out of an unnecessary repair.',
    }],
    stashCardActivities: [
      { id: 'act-09a', activityType: { call: { phone: '(404) 555-0000' } }, stashCardId: 'card-09', stasherId: 'stasher-russ', title: 'Call', detail: '', createdOn: new Date('2024-03-20') },
      { id: 'act-09b', activityType: { call: { phone: '(404) 555-0000' } }, stashCardId: 'card-09', stasherId: 'stasher-russ', title: 'Call', detail: '', createdOn: new Date('2024-02-10') },
      { id: 'act-09c', activityType: { call: { phone: '(404) 555-0000' } }, stashCardId: 'card-09', stasherId: 'stasher-russ', title: 'Call', detail: '', createdOn: new Date('2024-01-25') },
    ],
  },
  {
    recordID: 'card-10',
    stasherId: 'stasher-mike',
    vendor: vendorAuto,
    tags: ['mechanic'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-10', stashCardId: 'card-10', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Always calls before doing extra work. Rare.',
    }],
  },
  {
    recordID: 'card-11',
    stasherId: 'stasher-russ',
    vendor: vendorElectric,
    tags: ['permits', 'reliable'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-11', stashCardId: 'card-11', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Fast, clean, pulled permits. No shortcuts.',
    }],
  },
  {
    recordID: 'card-12',
    stasherId: 'stasher-jess',
    vendor: vendorCrossfit,
    tags: ['fitness', 'early-bird'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-12', stashCardId: 'card-12', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: '6am classes fill up fast. Sign up the night before.',
    }],
  },
  {
    recordID: 'card-13',
    stasherId: 'stasher-sarah',
    vendor: vendorHair,
    tags: ['haircut', 'atlanta'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-13', stashCardId: 'card-13', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Ask for Tomás. Best cut I\'ve had in Atlanta.',
    }],
  },
  {
    recordID: 'card-14',
    stasherId: 'stasher-russ',
    vendor: vendorHair,
    tags: ['parking'],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-14', stashCardId: 'card-14', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'Easy parking in the garage next door.',
    }],
  },

  {
    recordID: 'card-15',
    stasherId: 'stasher-russ',
    vendor: vendorSecurity,
    tags: [],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardNotes: [{
      recordID: 'note-15', stashCardId: 'card-15', title: '', isPrivate: false, attachments: [], createdOn: new Date('2024-01-15'),
      detail: 'So secure! Jules\'s personally handled every after-hours call. The bible verse was a bit much.',
    }],
  },
  {
    recordID: 'card-16',
    stasherId: ACKERMAN_STASHER_ID,
    vendor: vendorSecurity,
    tags: [],
    recordStatus: 'active',
    visibility: 'communityPrivate',
    meta: META,
    stashCardActivities: ackermanActivities,
    stashCardNotes: ackermanNotes,
  },
];
